// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2X_Ir","red":"Button-module--red--2dd03","grey":"Button-module--grey--2up4p"};